import React from 'react';
import Button from 'antd/lib/button';
import { HelpTip } from '../setup/shared';

export const QuestionsInfoSection: React.FC = () => {
    return (
        <HelpTip>
            Questions, or need more details?
            <Button type="link" style={{ padding: 0, display: 'inline', lineHeight: 'revert' }} href={`#hs-chat-open`}>
                Get in touch.
            </Button>
        </HelpTip>
    );
};
